import { IGeoObject } from '@cian/frontend-newbuilding-map-component/es/types';
import { IGetInfrastructureV4ResponseSchema } from 'shared/common/repositories/infrastructure-caching/entities/get_infrastructure/GetInfrastructureV4ResponseSchema';
import { transformFutureRoads } from 'shared/mf-infrastructure/mappers/transformGetInfrastructureV3Response/transformFutureRoads';
import { transformResultToMainGeoObjects } from 'shared/mf-infrastructure/mappers/transformGetInfrastructureV3Response/transformResultToMainGeoObjects';
import { TInfrastructureItem, TRegularInfrastructureType } from 'shared/mf-infrastructure/types/infrastructure';
import { getInfrastructureMapByYear } from 'shared/mf-infrastructure/utils/getInfrastructureMapByYear';
import { toGeoObjects } from 'shared/mf-infrastructure/utils/toGeoObjects';

export function transformResultToGeoObjects(result: IGetInfrastructureV4ResponseSchema): IGeoObject[] {
  const mainObjects = transformResultToMainGeoObjects(result);

  const existingInfrastructure = result.infrastructure.items.map(({ type, ...rest }) => ({
    ...rest,
    type: type as TRegularInfrastructureType,
  }));
  const futureInfrastructure = result.future?.infrastructure || [];
  const futureRoads = transformFutureRoads(result.future?.roads);

  const infrastructure: TInfrastructureItem[] = [...existingInfrastructure, ...futureInfrastructure, ...futureRoads];

  return toGeoObjects(
    getInfrastructureMapByYear(infrastructure, mainObjects, futureInfrastructure.length > 0),
    new Date().getFullYear(),
  );
}
